var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order order--checkout" }, [
    _c("h2", { staticClass: "caption caption--size_2" }, [
      _vm._v(_vm._s(_vm._("Checkout Form")))
    ]),
    _c("div", { staticClass: "order__content" }, [
      _c("p", { staticClass: "caption caption--size_3 caption--color_red" }, [
        _vm._v(_vm._s(_vm._("Prepayment:")) + " "),
        _c("span", [_vm._v(_vm._s(_vm.orderInfo.prepayment))])
      ]),
      _c("p", { staticClass: "text text--fs_md text--color_black" }, [
        _vm._v(_vm._s(_vm._("Final Payment:")) + " "),
        _c(
          "span",
          { staticClass: "text text--fs_md text--color_black text--fw_bold" },
          [_vm._v(_vm._s(_vm.finalPayment))]
        )
      ]),
      _c("p", { staticClass: "text text--fs_md text--color_black" }, [
        _vm._v(_vm._s(_vm._("Total Price:")) + " "),
        _c(
          "span",
          { staticClass: "text text--fs_md text--color_black text--fw_bold" },
          [_vm._v(_vm._s(_vm.orderInfo.price))]
        )
      ]),
      _c(
        "p",
        { staticClass: "text text--fw_bold text--fs_xl text--color_black" },
        [_vm._v(_vm._s(_vm._("Order details:")))]
      ),
      _c("p", { staticClass: "text text--fs_md text--color_black" }, [
        _vm._v(_vm._s(_vm._("Date:")) + " "),
        _vm.orderInfo.dateAt
          ? _c(
              "span",
              {
                staticClass: "text text--fs_md text--color_black text--fw_bold"
              },
              [_vm._v(_vm._s(_vm.orderInfo.dateAt.split("T")[0]))]
            )
          : _vm._e()
      ]),
      _c("p", { staticClass: "text text--fs_md text--color_black" }, [
        _vm._v(_vm._s(_vm._("Time:")) + " "),
        _vm.orderInfo.dateAt
          ? _c(
              "span",
              {
                staticClass: "text text--fs_md text--color_black text--fw_bold"
              },
              [_vm._v(_vm._s(_vm.orderInfo.dateAt.split("T")[1].split("Z")[0]))]
            )
          : _vm._e()
      ]),
      _vm.orderInfo.service_detail
        ? _c("div", [
            _c("p", { staticClass: "text text--fs_md text--color_black" }, [
              _vm._v(_vm._s(_vm._("Selected service:")) + " "),
              _c("span", {
                staticClass: "text text--fs_md text--color_black text--fw_bold"
              })
            ]),
            _c(
              "p",
              {
                staticClass: "text text--fs_md text--color_black text--fw_bold"
              },
              [_vm._v(_vm._s(_vm.orderInfo.service_detail.title))]
            ),
            _c("p", {
              staticClass: "text text--fs_md text--color_black",
              domProps: {
                innerHTML: _vm._s(_vm.orderInfo.service_detail.description)
              }
            })
          ])
        : _vm._e()
    ]),
    _c(
      "div",
      { staticClass: "order__content" },
      [
        _c("validation-observer", {
          ref: "observer",
          attrs: { tag: "form" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.validateBeforeSubmit($event)
            }
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(props) {
                return [
                  _c("div", { staticClass: "ug-row ug-row--offset_sm" }, [
                    _c(
                      "div",
                      { staticClass: "ug-cell ug-cols" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            tag: "div",
                            rules: "required",
                            name: "name"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("ui-input", {
                                      staticClass: "control--xl",
                                      attrs: {
                                        type: "text",
                                        errors: errors,
                                        label: _vm._("Full Name")
                                      },
                                      model: {
                                        value: _vm.formdata.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.formdata, "name", $$v)
                                        },
                                        expression: "formdata.name"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "ug-cell ug-cols ug-cols--6-sm" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            tag: "div",
                            rules: "required",
                            name: "car_registration"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("ui-input", {
                                      staticClass: "control--xl",
                                      attrs: {
                                        type: "text",
                                        errors: errors,
                                        label: _vm._("Car registration number")
                                      },
                                      model: {
                                        value: _vm.formdata.car_registration,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formdata,
                                            "car_registration",
                                            $$v
                                          )
                                        },
                                        expression: "formdata.car_registration"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "ug-cell ug-cols ug-cols--6-sm" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            tag: "div",
                            rules: "required",
                            name: "phone"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("ui-input", {
                                      staticClass: "control--xl",
                                      attrs: {
                                        type: "text",
                                        errors: errors,
                                        label: _vm._("Phone")
                                      },
                                      model: {
                                        value: _vm.formdata.phone,
                                        callback: function($$v) {
                                          _vm.$set(_vm.formdata, "phone", $$v)
                                        },
                                        expression: "formdata.phone"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "ug-cell ug-cols ug-cols--6-sm" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            tag: "div",
                            rules: "required",
                            name: "address"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("ui-input", {
                                      staticClass: "control--xl",
                                      attrs: {
                                        type: "text",
                                        errors: errors,
                                        label: _vm._("Address")
                                      },
                                      model: {
                                        value: _vm.formdata.address,
                                        callback: function($$v) {
                                          _vm.$set(_vm.formdata, "address", $$v)
                                        },
                                        expression: "formdata.address"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "ug-cell ug-cols ug-cols--6-sm" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            tag: "div",
                            rules: "required",
                            name: "post_code"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("ui-input", {
                                      staticClass: "control--xl",
                                      attrs: {
                                        type: "text",
                                        errors: errors,
                                        label: _vm._(
                                          "Postal code (where to drive)"
                                        )
                                      },
                                      model: {
                                        value: _vm.formdata.post_code,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formdata,
                                            "post_code",
                                            $$v
                                          )
                                        },
                                        expression: "formdata.post_code"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _c("div", { staticClass: "ug-cell ug-cols" }, [
                      _c("div", { staticClass: "ug-row ug-row--offset_sm" }, [
                        _c(
                          "div",
                          { staticClass: "ug-cell ug-cols" },
                          [
                            _c(
                              "file-uploader",
                              {
                                attrs: {
                                  id: "upload",
                                  "max-files": 5,
                                  "multiple-files": true,
                                  "accepted-files": ".jpg, .jpeg, .png",
                                  "max-size": 10
                                },
                                on: { "files-change": _vm.filesChange },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "info",
                                      fn: function(ref) {
                                        var maxFiles = ref.maxFiles
                                        var maxSize = ref.maxSize
                                        var acceptedFiles = ref.acceptedFiles
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "upload__info" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "text" },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        _vm._(
                                                          "Maximum number of files - "
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(maxFiles) +
                                                      ", "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._(
                                                        "maximum file size - "
                                                      )
                                                    ) +
                                                      " " +
                                                      _vm._s(maxSize) +
                                                      " " +
                                                      _vm._s(_vm._("MB")) +
                                                      ", "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._(
                                                        "allowed formats - "
                                                      )
                                                    ) +
                                                      " " +
                                                      _vm._s(acceptedFiles) +
                                                      ")"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "filesName",
                                      fn: function(ref) {
                                        var filesName = ref.filesName
                                        var index = ref.index
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(filesName[index]))
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _c("template", { slot: "button" }, [
                                  _c("div", { staticClass: "upload__button" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "button button--height_xl button--bg_transparent button--border_common"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "button__icon" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon icon--type_attach"
                                            })
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "button__text" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm._("Attach files"))
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]),
                                _c("template", { slot: "remove" }, [
                                  _c("i", {
                                    staticClass: "icon icon--type_close"
                                  })
                                ])
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _c("validation-provider", {
                    staticClass: "mt-20",
                    attrs: {
                      tag: "div",
                      rules: { required: { allowFalse: false } },
                      name: "terms"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("div", { staticClass: "checkbox-wrapper" }, [
                                _c(
                                  "div",
                                  { staticClass: "checkbox-wrapper__body" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "control-checkbox" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.terms,
                                              expression: "terms"
                                            }
                                          ],
                                          staticClass:
                                            "control-checkbox__element",
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(_vm.terms)
                                              ? _vm._i(_vm.terms, null) > -1
                                              : _vm.terms
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = _vm.terms,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.terms = $$a.concat([
                                                      $$v
                                                    ]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.terms = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.terms = $$c
                                              }
                                            }
                                          }
                                        }),
                                        _c("span", {
                                          staticClass: "control-checkbox__label"
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "checkbox-wrapper__content" },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text text--color_black text--lh_xxs"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm._("I agree with")) + " "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "link",
                                            attrs: {
                                              href: _vm.termsPageUrl,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._("Terms and Conditions")
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass: "help help--type_error",
                                  class: { "is-error": errors[0] }
                                },
                                [_vm._v(_vm._s(errors[0]))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _c("validation-provider", {
                    staticClass: "mt-20",
                    attrs: { tag: "div", name: "detail" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              errors[0]
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "help help--type_error",
                                      class: { "is-error": errors[0] }
                                    },
                                    [_vm._v(_vm._s(errors[0]))]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _c("div", { staticClass: "order__content" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ug-row ug-row--offset_sm ug-row--alignment_center"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "ug-cell ug-cols ug-cols--6-sm" },
                          [
                            _c("p", { staticClass: "text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._(
                                    "This link will expire in two hours, so please dont postpone your payment"
                                  )
                                )
                              )
                            ])
                          ]
                        ),
                        !_vm.paymentIsAllowed
                          ? _c(
                              "div",
                              { staticClass: "ug-cell ug-cols ug-cols--6-sm" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "button",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.validateBeforeSubmit($event)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm._("Prepayment")) +
                                        " " +
                                        _vm._s(_vm.orderInfo.prepayment)
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.paymentIsAllowed,
                          expression: "paymentIsAllowed"
                        }
                      ],
                      staticClass: "js-paypal paypal-buttons"
                    })
                  ])
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e5c915a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e5c915a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Order/Checkout.vue
// module id = 973
// module chunks = 0